import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Helmet } from 'react-helmet-async';
import logoCircle from '../assets/logo/RJ_circle_512.png';
import logoBingo from '../assets/logo/RJ_bingo.png';

const defaultSongs = [
  'Pretty Woman - Roy Orbison',
  'Supercalifragilisticoespialidoso - Mary Poppins',
  'Mi gran noche - Raphael',
  'Libre - Nino Bravo',
  'Mi carro - Manolo Escobar',
  'Que viva España - Manolo Escobar',
  'Waterloo - ABBA',
  'Mamma Mia - ABBA',
  'Campanera - Rocío Jurado / Joselito',
  'Vivir así es morir de amor - Camilo Sesto',
  'Chica de ayer - Nacha Pop',
  'Thriller - Michael Jackson',
  'No controles - Olé Olé',
  'Lobo hombre en París - La Unión',
  'Sufre mamón - Hombres G',
  'A quién le importa - Alaska y Dinarama',
  'Hijo de la luna - Mecano',
  'Bamboleo - Gipsy Kings',
  'Eloise - Tino Casal',
  'Himno del Real Madrid - José de Aguilar',
  'Veneno en la piel - Radio Futura',
  'Entre dos tierras - Héroes del Silencio',
  'Bailar pegados - Sergio Dalma',
  'Cómo hemos cambiado - Presuntos Implicados',
  '20 de abril - Celtas Cortos',
  'La Macarena - Los del Río',
  'El tractor amarillo - Zapato Veloz',
  'Hakuna Matata - Disney - El Rey León',
  'So payaso - Extremoduro',
  'Corazón partío - Alejandro Sanz',
  'Ciega, sordomuda - Shakira',
  'Por la raja de tu falda - Estopa',
  'La Lola - Café Quijano',
  'Color esperanza - Diego Torres',
  'Ave María - David Bisbal',
  'Dos hombres y un destino - Bustamante & Casademunt',
  'Un violinista en tu tejado - Melendi',
  'Aserejé (The Ketchup Song) - Las Ketchup',
  'Marta, Sebas, Guille y los demás - Amaral',
  'We`re All in This Together - High School Musical',
  'Love Story - Taylor Swift',
  'This Is Me - Demi Lovato & Joe Jonas (Camp Rock)',
  'Mari Carmen - La Pegatina',
  'Waka Waka (This Time for Africa) - Shakira',
  'Yo te esperaré - Cali y el Dandee',
  'Lágrimas desordenadas - Melendi',
  'Thinking Out Loud - Ed Sheeran',
  'Uptown Funk - Mark Ronson ft. Bruno Mars',
  'Me Rehúso - Danny Ocean',
  'Despacito - Luis Fonsi y Daddy Yankee',
  'Quédate - Quevedo',
  'Si te pillara - Beéle',
  'Si no estás - Íñigo Quintero',
  'Nochentera - Vicco',
  'Capaz - Beéle',
  'No tiene sentido - Beéle',
  'La plena - Beéle',
  '6 de febrero - Aitana',
];

const MainWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  background-image: url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0,15 Q40,10 80,15' stroke='%23555' stroke-width='1' fill='none'/%3E%3Cpath d='M0,25 Q40,20 80,25' stroke='%23555' stroke-width='1' fill='none'/%3E%3Cpath d='M0,35 Q40,30 80,35' stroke='%23555' stroke-width='1' fill='none'/%3E%3Cpath d='M0,45 Q40,40 80,45' stroke='%23555' stroke-width='1' fill='none'/%3E%3Cpath d='M0,55 Q40,50 80,55' stroke='%23555' stroke-width='1' fill='none'/%3E%3Ctext x='8' y='18' font-size='22' font-family='Arial' fill='%23000'%3E%E2%99%AA%3C/text%3E%3Ctext x='28' y='38' font-size='18' font-family='Arial' fill='%23000'%3E%E2%99%AB%3C/text%3E%3Ctext x='50' y='14' font-size='24' font-family='Arial' fill='%23000'%3E%E2%99%AC%3C/text%3E%3Ctext x='62' y='52' font-size='16' font-family='Arial' fill='%23000'%3E%E2%99%AA%3C/text%3E%3Ctext x='12' y='67' font-size='14' font-family='Arial' fill='%23000'%3E%E2%99%AB%3C/text%3E%3Ctext x='38' y='72' font-size='20' font-family='Arial' fill='%23000'%3E%E2%99%AC%3C/text%3E%3C/svg%3E");
  background-size: 80px 93px;
  background-repeat: repeat;
  background-color: #e58686;
`;

const logoSize = 135;

const LogoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* que no bloquee clics */

  background-image: url(${logoCircle}), url(${logoCircle});
  background-size: ${logoSize}px ${logoSize}px, ${logoSize}px ${logoSize}px;
  background-position: 0 0, -${logoSize / 2}px -${logoSize / 2}px;
  background-repeat: repeat, repeat;
  opacity: 0.4;

  @media print {
    background-image: url(${logoCircle}), url(${logoCircle});
    background-size: ${logoSize / 4}px ${logoSize / 4}px, ${logoSize / 4}px ${logoSize / 4}px;
    background-position: 0 0, -${logoSize / 8}px -${logoSize / 8}px;
    background-repeat: repeat, repeat;
    opacity: 0.4;
    transform: scaleX(-1);
    rotate: 180deg;
  }
`;

const GlobalPrintStyles = createGlobalStyle`
  @media print {
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`;

const PrintButton = styled.button`
  margin: 12px;
  margin-left: 20px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 4px;

  @media print {
    display: none;
  }
`;

const NumberInput = styled.input`
  padding: 6px;
  width: 100px;
  font-size: 20px;
  background: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 4px;
  text-align: center;

  @media print {
    display: none;
  }
`;

const ControlsContainer = styled.div`
  z-index: 10;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px 0;

  @media print {
    display: none !important;
    height: 0;
    margin: 0;
    padding: 0;
  }
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px;
  margin-bottom: 100px;
  background: black;
  padding: 4px 20px;
  border-radius: 8px;
  justify-content: center;
  align-self: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    margin: 10px;

    margin-bottom: 150px;
  }
`;

const ControlsText = styled.div`
  font-size: 14px;
  color: white;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  a {
    color: #fff;
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
  }

  &::after {
    content: 'Puedes cargar una playlist de youtube poniendo el id de playlist en la url (?playlist=...)';
    position: absolute;
    min-width: 200px;
    bottom: -220%;
    left: 50%;
    transform: translateX(-50%);
    background: black;
    color: white;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    pointer-events: none;
    z-index: 10;
  }

  &:hover::after {
    opacity: 1;
    visibility: visible;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    text-align: center;
  }
`;

const Label = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: white;
`;

// Contenedor general
const Container = styled.div`
  z-index: 10;

  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  > div {
    margin-bottom: 300px;
  }

  @media (max-width: 768px) {
    > div {
      margin-bottom: 700px;
    }
  }

  @media print {
    > div {
      margin-bottom: 0;
    }
  }
`;

// Header estilo imagen
const Header = styled.div`
  background: black;
  color: white;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  padding: 10px;
  border: 4px solid black;
  margin: 0 auto 2px auto;
  letter-spacing: 2px;
  width: 650px;

  @media (max-width: 768px) {
    width: 90%;
  }

  @media print {
    width: 87%;
  }
`;

// Estilos de cada cartón
const BingoCard = styled.div`
  background: white;
  border: 4px solid black;
  margin-top: 4px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 80px);
  width: 650px;

  @media (max-width: 768px) {
    width: 90%;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 1fr);
  }

  @media print {
    width: 87%;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
`;

const SongCell = styled.div`
  background: white;
  border: 2px solid black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-transform: uppercase;
  padding: 2px;
  min-width: 0;
  width: 100%;
  height: 80px;
  overflow-wrap: break-word;
  word-break: break-word;

  .title {
    font-size: 12px;
    font-weight: bold;
  }

  .artist {
    font-size: 10px;
    font-weight: normal;
  }

  @media (max-width: 768px) {
    padding: 4px;
  }

  @media print {
    height: 80px;
  }
`;

const PrintableWrapper = styled.div`
  page-break-inside: avoid;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media print {
    width: 100%;
  }
`;

const CardsPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;
  gap: 40px;
  width: 100%;
  padding: 20px 0;

  @media print {
    page-break-after: always;
    padding: 20px 0;
  }
`;

export default function BingoMusical() {
  useEffect(() => {
    let favicon = document.querySelector("link[rel='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = logoBingo;
  }, []);

  const [cards, setCards] = useState([]);
  const [numCards, setNumCards] = useState(42);
  const [songList, setSongList] = useState([]);

  const playlistId =
    new URLSearchParams(window.location.search).get('playlist') || 'PL2AC2Znfs7pSexrmRzpXGMsDShstsn7hw';

  useEffect(() => {
    async function fetchAllSongs() {
      let allSongs = [];
      try {
        const response = await fetch(`https://api.juangutierreza.com/rj/yt/getPlaylist?id=${playlistId}`);
        const data = await response.json();
        if (data.songs && data.songs.length > 0) {
          const songs = data.songs.map((song) => `${song.title} - ${song.artist}`);
          allSongs = allSongs.concat(songs);
          setSongList(allSongs);
        } else {
          setSongList(defaultSongs);
        }
      } catch (error) {
        setSongList(defaultSongs);
      }
    }
    fetchAllSongs();
  }, [playlistId]);

  useEffect(() => {
    if (songList.length > 0) {
      const generatedCards = generateUniqueBingoCards(songList, numCards, 12);
      setCards(generatedCards);
    }
  }, [numCards, songList]);

  // Agrupar cartas en páginas de 3
  const cardsPages = [];
  for (let i = 0; i < cards.length; i += 3) {
    cardsPages.push(cards.slice(i, i + 3));
  }

  return (
    <>
      <Helmet>
        <title>Bingo Musical 🎶</title>
        <meta name="description" content="Crea al bingo musical con tus canciones favoritas." />
        <link rel="icon" href={logoBingo} />
      </Helmet>

      <GlobalPrintStyles />
      <MainWrapper>
        <LogoOverlay />

        <ControlsContainer>
          <Controls>
            <Label>Número de cartones:</Label>
            <NumberInput
              type="number"
              value={numCards}
              min={0}
              onChange={(e) => setNumCards(parseInt(e.target.value) || 1)}
            />

            <ControlsText>
              Las canciones salen de
              <a
                href={'https://music.youtube.com/playlist?list=' + playlistId}
                rel="noopener noreferrer"
                target="_blank"
              >
                esta playlist
              </a>
            </ControlsText>

            <PrintButton onClick={() => window.print()}>Descargar PDF</PrintButton>
          </Controls>
        </ControlsContainer>

        <Container>
          {cardsPages.map((page, pageIndex) => (
            <CardsPage key={pageIndex}>
              {page.map((card, i) => {
                const seenSongs = new Set();
                return (
                  <PrintableWrapper key={i}>
                    <Header>BINGO MUSICAL</Header>
                    <BingoCard>
                      {card.map((song, j) => {
                        const isDuplicate = seenSongs.has(song);
                        if (!isDuplicate) {
                          seenSongs.add(song);
                        }
                        const [title, artist] = song.split(' - ');
                        return (
                          <SongCell key={j} style={isDuplicate ? { backgroundColor: 'red', color: 'white' } : {}}>
                            <div className="title">
                              {title.includes('(') ? (
                                <>
                                  {title.substring(0, title.indexOf('('))}
                                  <br />
                                  {title.substring(title.indexOf('('))}
                                </>
                              ) : (
                                title
                              )}
                            </div>
                            <div className="artist">{artist}</div>
                          </SongCell>
                        );
                      })}
                    </BingoCard>
                  </PrintableWrapper>
                );
              })}
            </CardsPage>
          ))}
        </Container>
      </MainWrapper>
    </>
  );
}

// Función para generar cartones únicos
function generateUniqueBingoCards(songs, numberOfCards, songsPerCard) {
  const allCards = new Set();
  const cards = [];

  while (cards.length < numberOfCards) {
    const shuffled = [...songs].sort(() => 0.5 - Math.random());
    const selected = shuffled.slice(0, songsPerCard);
    const key = selected.sort().join('|');

    if (!allCards.has(key)) {
      allCards.add(key);
      cards.push(selected);
    }
  }

  return cards;
}
